(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending-categories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('addax-category-strip')) {
  customElements.define('addax-category-strip', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.abort) return;
      this.track = this.querySelector('.categories-grid-layout-el');
      if (!this.track) return;
      this.desktop = matchMedia('(min-width:1101px)');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.abort = new AbortController();
      const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal:this.abort.signal});
      on(this.track, 'pointerdown', e => {
        this.suppressClick = false;
        if (!this.desktop.matches || e.pointerType !== 'mouse' || e.button !== 0 || this.track.scrollWidth <= this.track.clientWidth) return;
        const r = this.track.getBoundingClientRect();
        if (e.clientY >= r.top + this.track.clientHeight) return; // Native scrollbar remains native.
        this.drag = {id:e.pointerId,x:e.clientX,y:e.clientY,left:this.track.scrollLeft,moved:false};
      });
      on(window, 'pointermove', e => {
        const d = this.drag;
        if (!d || d.id !== e.pointerId) return;
        const dx = e.clientX - d.x, dy = e.clientY - d.y;
        if (!d.moved) {
          if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { this.finishDrag(); return; }
          if (Math.abs(dx) < 6) return;
          d.moved = true;
          this.classList.add('is-dragging');
          this.track.setPointerCapture(e.pointerId);
        }
        e.preventDefault();
        this.track.scrollLeft = d.left - dx;
      }, {passive:false});
      on(window, 'pointerup', e => { if (this.drag?.id === e.pointerId) this.finishDrag(); });
      on(window, 'pointercancel', () => this.finishDrag());
      on(this.track, 'lostpointercapture', () => this.finishDrag());
      on(window, 'blur', () => this.finishDrag());
      on(this.track, 'dragstart', e => { if (this.desktop.matches) e.preventDefault(); });
      on(this.track, 'click', e => {
        if (this.suppressClick && e.detail !== 0) { e.preventDefault(); e.stopImmediatePropagation(); this.suppressClick = false; }
      }, {capture:true});
      on(this, 'click', e => {
        const button = e.target.closest('[data-category-direction]');
        if (!button || !this.desktop.matches || button.disabled) return;
        const card = this.track.firstElementChild;
        const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        this.track.scrollBy({left:Number(button.dataset.categoryDirection) * step,behavior:this.motion.matches ? 'auto' : 'smooth'});
      });
      on(this.track, 'scroll', () => this.queueUpdate(), {passive:true});
      on(this.desktop, 'change', () => { this.finishDrag(); this.suppressClick = false; this.update(); });
      this.resize = new ResizeObserver(() => { this.finishDrag(); this.queueUpdate(); });
      this.resize.observe(this.track);
      this.classList.add('is-ready');
      this.update();
    }
    finishDrag() {
      const d = this.drag;
      this.drag = null;
      if (d?.moved) this.suppressClick = true;
      this.classList.remove('is-dragging');
      if (d && this.track?.hasPointerCapture(d.id)) this.track.releasePointerCapture(d.id);
    }
    queueUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.update());
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.querySelector('[data-category-direction="-1"]').disabled = this.track.scrollLeft <= 1;
      this.querySelector('[data-category-direction="1"]').disabled = this.track.scrollLeft >= max - 1;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame); cancelAnimationFrame(this.updateFrame);
      this.finishDrag(); this.abort?.abort(); this.abort = null; this.resize?.disconnect();
      this.classList.remove('is-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('addax-campaign-slider')) return;
  customElements.define('addax-campaign-slider', class extends HTMLElement {
    connectedCallback() {
      this.start = () => { this.initFrame = requestAnimationFrame(() => this.init()); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',this.start,{once:true});
      else this.start();
    }
    on(target, name, callback, options = {}) { target?.addEventListener(name, callback, {...options, signal:this.abort.signal}); }
    init() {
      if (this.abort || !this.isConnected) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.abort = new AbortController();
      this.stage = this.querySelector('.acs__stage');
      this.mobile = matchMedia('(max-width:749px)');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.index = 0; this.hovered = false; this.editorSelected = false;
      this.rotationPaused = this.dataset.autoplay !== 'true' || this.motion.matches || !!navigator.connection?.saveData;
      this.interval = Math.max(4000, Number(this.dataset.interval) || 7000);
      this.on(this, 'pointerdown', () => { this.suppressClickUntil = 0; }, {capture:true});
      this.on(this, 'click', e => this.click(e));
      this.on(this, 'keydown', e => {
        if (e.target.closest('input,textarea,select,[contenteditable]')) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1), true); }
      });
      this.on(this, 'pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      this.on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      this.on(this, 'focusin', e => {
        this.rotationPaused = true; this.schedule();
      });
      this.on(this.stage, 'pointerdown', e => this.dragStart(e));
      this.on(window, 'pointermove', e => this.dragMove(e), {passive:false});
      this.on(window, 'pointerup', e => this.dragEnd(e));
      this.on(window, 'pointercancel', e => this.dragEnd(e, true));
      this.on(this.stage, 'lostpointercapture', e => this.dragEnd(e, true));
      this.on(window, 'blur', () => { this.dragEnd(null, true, true); this.finishTransition(); });
      this.on(this.stage, 'dragstart', e => { if (this.gesture) e.preventDefault(); });
      this.on(this, 'click', e => { if (e.detail !== 0 && Date.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); e.stopImmediatePropagation(); } }, {capture:true});
      this.on(document, 'visibilitychange', () => { if (document.hidden) { this.dragEnd(null, true, true); this.finishTransition(); } this.sync(); });
      this.on(window, 'resize', () => { this.dragEnd(null, true, true); this.finishTransition(); this.queueViewportFit(); });
      this.on(this.mobile, 'change', () => { this.dragEnd(null, true, true); this.finishTransition(); this.slides.forEach(s => this.release(s)); this.sync(); });
      this.on(this.motion, 'change', () => {
        this.dragEnd(null, true, true); this.finishTransition();
        if (this.motion.matches) { this.rotationPaused = true; this.slides.forEach(s => { s.dataset.manualPlay = 'false'; s.querySelector('video')?.pause(); }); }
        this.sync();
      });
      this.on(this, 'shopify:block:select', e => {
        const index = this.slides.findIndex(s => s.dataset.blockId === e.detail?.blockId);
        if (index >= 0) { this.editorSelected = true; this.show(index, true); }
      });
      this.on(this, 'shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); });
      this.slides.forEach(slide => {
        const v = slide.querySelector('video');
        if (!v) return;
        v.defaultMuted = true; v.muted = true; v.playsInline = true;
        this.on(v, 'playing', () => {
          if (slide !== this.slides[this.index] || !this.visible || document.hidden) { v.pause(); return; }
          slide.classList.add('has-frame'); this.message(slide, ''); this.videoUI(slide);
        });
        ['pause','volumechange','loadeddata'].forEach(name => this.on(v, name, () => this.videoUI(slide)));
        this.on(v, 'ended', () => { slide.dataset.userPaused = 'true'; this.videoUI(slide); });
        this.on(v, 'error', () => { slide.classList.remove('has-frame'); this.message(slide, 'Video unavailable. Tap play to retry.'); this.videoUI(slide); });
        this.on(slide.querySelector('[data-volume]'), 'input', e => { v.volume = Number(e.target.value); v.muted = v.volume === 0; this.videoUI(slide); });
      });
      this.setupViewportFit();
      this.classList.add('is-ready');
      const box = this.stage.getBoundingClientRect();
      this.visible = box.top < innerHeight && box.bottom > 0;
      this.show(0);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.sync(); }, {threshold:0});
        this.observer.observe(this.stage);
      } else {
        const check = () => { const r = this.stage.getBoundingClientRect(); this.visible = r.top < innerHeight && r.bottom > 0; this.sync(); };
        this.on(window, 'scroll', check, {passive:true}); this.on(window, 'resize', check, {passive:true});
      }
    }
    updateViewportFit() {
      if (!this.abort || !this.classList.contains('acs--desktop-viewport')) return;
      if (this.mobile.matches) { this.style.removeProperty('--acs-stage-top'); return; }
      // Document position keeps the banner stable when the customer scrolls.
      // Measure the real start, so an overlay header is not subtracted twice.
      const documentTop = Math.max(0,this.stage.getBoundingClientRect().top + window.scrollY);
      const offset = documentTop < innerHeight ? documentTop : 0;
      const value = Math.round(offset * 100) / 100 + 'px';
      if (this.style.getPropertyValue('--acs-stage-top') !== value) this.style.setProperty('--acs-stage-top',value);
    }
    queueViewportFit() {
      if (!this.classList.contains('acs--desktop-viewport')) return;
      cancelAnimationFrame(this.viewportFrame);
      this.viewportFrame = requestAnimationFrame(() => this.updateViewportFit());
    }
    setupViewportFit() {
      if (!this.classList.contains('acs--desktop-viewport')) return;
      this.updateViewportFit();
      this.on(window,'load',() => this.queueViewportFit());
      this.on(window,'pageshow',() => this.queueViewportFit());
      if (!('ResizeObserver' in window)) return;
      this.viewportObserver = new ResizeObserver(() => this.queueViewportFit());
      // Watch the content above this section (announcement/menu), not the hero's own height.
      for (let branch = this; branch && branch !== document.body; branch = branch.parentElement) {
        for (let previous = branch.previousElementSibling; previous; previous = previous.previousElementSibling) {
          if (!/^(SCRIPT|STYLE|LINK|META|TEMPLATE)$/.test(previous.tagName)) this.viewportObserver.observe(previous);
        }
      }
    }
    hydrate(slide) {
      const template = slide.querySelector('template[data-poster]');
      if (template) { const fragment = template.content.cloneNode(true); fragment.querySelector('img')?.setAttribute('loading','eager'); template.replaceWith(fragment); }
    }
    dragStart(e) {
      if (e.isPrimary === false) { this.dragEnd(null, true); return; }
      if (this.slides.length < 2 || e.button !== 0 || e.target.closest('button,input,textarea,select,iframe,[contenteditable],a:not(.acs__full-link)')) return;
      if (this.transition) { e.preventDefault(); this.suppressClickUntil = Date.now() + 700; return; }
      this.gesture = {id:e.pointerId,x:e.clientX,y:e.clientY,dx:0,offset:0,width:this.stage.clientWidth,dragging:false,slide:this.slides[this.index]};
      for (const step of [-1,1]) this.hydrate(this.slides[(this.index + step + this.slides.length) % this.slides.length]);
      clearTimeout(this.timer);
    }
    dragMove(e) {
      const g = this.gesture;
      if (!g || e.pointerId !== g.id) return;
      const dx = e.clientX - g.x, dy = e.clientY - g.y;
      if (!g.dragging) {
        if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { this.dragEnd(e, true); return; }
        if (Math.abs(dx) < 12 || Math.abs(dx) <= Math.abs(dy) * 1.5) return;
        g.dragging = true; this.rotationPaused = true; this.classList.add('is-dragging');
        this.stage.setPointerCapture(e.pointerId);
      }
      e.preventDefault(); g.dx = dx;
      const width = g.width, direction = dx < 0 ? 1 : -1;
      const adjacent = this.slides[(this.index + direction + this.slides.length) % this.slides.length];
      if (g.adjacent && g.adjacent !== adjacent) { g.adjacent.hidden = true; g.adjacent.style.removeProperty('transform'); }
      g.adjacent = adjacent; this.hydrate(adjacent); adjacent.hidden = false;
      const offset = Math.max(-width, Math.min(width, dx));
      g.offset = offset; g.direction = direction;
      g.slide.style.transform = 'translate3d(' + offset + 'px,0,0)';
      adjacent.style.transform = 'translate3d(' + (offset + direction * width) + 'px,0,0)';
    }
    dragEnd(e, cancelled = false, immediate = false) {
      const g = this.gesture;
      if (!g || (e && e.pointerId !== g.id)) return;
      this.gesture = null; this.classList.remove('is-dragging');
      if (this.stage.hasPointerCapture(g.id)) this.stage.releasePointerCapture(g.id);
      if (g.dragging) {
        this.suppressClickUntil = Date.now() + 700;
        if (!immediate) {
          const advance = !cancelled && Math.abs(g.dx) >= Math.min(80, g.width * .15);
          const target = advance ? (this.index + g.direction + this.slides.length) % this.slides.length : this.index;
          this.transitionTo(target, g.direction, true, g.offset, g.adjacent); return;
        }
      }
      g.slide.style.removeProperty('transform');
      if (g.adjacent) { g.adjacent.hidden = true; g.adjacent.style.removeProperty('transform'); }
      this.schedule();
    }
    transitionTo(target, direction, manual, offset = 0, preview = null) {
      const outgoing = this.slides[this.index], incoming = preview || this.slides[target];
      const advance = target !== this.index, width = this.stage.clientWidth;
      clearTimeout(this.timer); clearTimeout(this.warmTimer);
      if (manual) this.rotationPaused = true;
      if (incoming === outgoing || !width || !this.visible || document.hidden || this.motion.matches || !outgoing.animate) {
        this.commit(target, manual); return;
      }
      this.hydrate(incoming); incoming.hidden = false;
      if (outgoing.contains(document.activeElement)) this.querySelectorAll('[data-slide-to]')[target]?.focus({preventScroll:true});
      outgoing.inert = true; incoming.inert = true; incoming.setAttribute('aria-hidden','true');
      this.classList.add('is-settling');
      const translate = x => 'translate3d(' + x + 'px,0,0)';
      const distance = advance ? width - Math.abs(offset) : Math.abs(offset);
      const duration = advance ? Math.round(320 + 180 * Math.min(1,distance / width)) : 280;
      const timing = {duration,easing:'cubic-bezier(0.22, 1, 0.36, 1)',fill:'forwards'};
      const animations = [
        outgoing.animate([{transform:translate(offset)},{transform:translate(advance ? -direction * width : 0)}],timing),
        incoming.animate([{transform:translate(offset + direction * width)},{transform:translate(advance ? 0 : direction * width)}],timing)
      ];
      const state = {animations,target,manual};
      state.finish = () => {
        if (this.transition !== state) return;
        this.transition = null; this.classList.remove('is-settling');
        this.commit(target,manual);
        animations.forEach(a => a.cancel());
        const queued = this.queuedSlide; this.queuedSlide = null;
        if (queued) this.show(queued.next,queued.manual);
      };
      this.transition = state;
      Promise.all(animations.map(a => a.finished)).then(state.finish, () => { if (this.transition === state) state.finish(); });
    }
    finishTransition() {
      this.queuedSlide = null;
      this.transition?.finish();
    }
    warmNext() {
      clearTimeout(this.warmTimer);
      if (this.slides.length < 2 || navigator.connection?.saveData) return;
      this.warmTimer = setTimeout(() => {
        if (this.abort && this.visible && !document.hidden && !this.gesture && !this.transition) this.hydrate(this.slides[(this.index + 1) % this.slides.length]);
      },800);
    }
    message(slide, text) { const el = slide.querySelector('[data-video-message]'); if (el) { el.textContent = text; el.hidden = !text; } }
    source(slide) {
      let data;
      try { data = JSON.parse(slide.querySelector('[data-video-sources]').textContent); } catch { return null; }
      const list = this.mobile.matches ? data.mobile : data.desktop;
      const candidates = (Array.isArray(list) ? list : []).filter(s => s.url);
      const mp4 = candidates.filter(s => s.format === 'mp4' || s.mime_type === 'video/mp4' || /\.mp4(?:\?|$)/i.test(s.url)).sort((a,b) => (a.width || 0) - (b.width || 0));
      const target = Math.min(this.mobile.matches ? 900 : 1600, this.stage.clientWidth * Math.min(devicePixelRatio || 1, 1.5));
      return mp4.find(s => s.width >= target) || mp4.at(-1) || candidates.find(s => slide.querySelector('video').canPlayType(s.mime_type || ''));
    }
    play(slide, retry = false) {
      const v = slide.querySelector('video');
      if (!v || slide.pendingPlay || (!v.paused && !v.ended)) return;
      if (retry && v.error) this.release(slide);
      if (!v.getAttribute('src')) {
        const selected = this.source(slide);
        if (!selected) { this.message(slide, 'Select a supported Shopify video, then try again.'); return; }
        v.src = selected.url; v.load();
      }
      if (v.ended) v.currentTime = 0;
      const attempt = v.play();
      slide.pendingPlay = attempt;
      attempt?.catch(error => {
        if (!this.abort || slide.hidden || error.name === 'AbortError') return;
        this.message(slide, error.name === 'NotAllowedError' ? 'Tap play to start the video.' : 'Video unavailable. Tap play to retry.');
        this.videoUI(slide);
      }).finally(() => { if (slide.pendingPlay === attempt) slide.pendingPlay = null; });
    }
    release(slide) {
      const v = slide.querySelector('video');
      if (v) { v.pause(); if (v.hasAttribute('src')) { v.removeAttribute('src'); v.load(); } }
      slide.pendingPlay = null; slide.classList.remove('has-frame','is-playing');
    }
    stopExternal(slide) {
      slide.querySelector('iframe')?.remove(); slide.classList.remove('has-external');
      const b = slide.querySelector('[data-external-play]'); if (b) b.hidden = false;
    }
    sync() {
      if (!this.abort) return;
      this.slides.forEach((slide,index) => {
        if (index !== this.index || !this.visible || document.hidden) { slide.querySelector('video')?.pause(); this.stopExternal(slide); return; }
        this.hydrate(slide);
        if (slide.dataset.userPaused !== 'true' && (slide.dataset.manualPlay === 'true' || (!this.motion.matches && !navigator.connection?.saveData))) this.play(slide);
      });
      this.schedule();
    }
    show(next, manual = false) {
      if (this.gesture) this.dragEnd(null, true, true);
      if (this.transition) { this.queuedSlide = {next,manual}; return; }
      const target = ((next % this.slides.length) + this.slides.length) % this.slides.length;
      if (target === this.index) { this.commit(target,manual); return; }
      const direction = next === this.index - 1 ? -1 : next === this.index + 1 ? 1 : target > this.index ? 1 : -1;
      this.transitionTo(target,direction,manual);
    }
    commit(target, manual = false) {
      this.index = target;
      if (manual) this.rotationPaused = true;
      this.slides.forEach((slide,index) => {
        const active = index === this.index;
        if (!active && slide.contains(document.activeElement)) this.querySelectorAll('[data-slide-to]')[this.index]?.focus({preventScroll:true});
        slide.style.removeProperty('transform');
        slide.hidden = !active; slide.inert = !active; slide.setAttribute('aria-hidden',String(!active));
        if (!active) { this.release(slide); this.stopExternal(slide); }
      });
      this.querySelectorAll('[data-slide-to]').forEach((b,index) => { if (index === this.index) b.setAttribute('aria-current','true'); else b.removeAttribute('aria-current'); });
      if (manual) this.querySelector('[data-status]').textContent = 'Slide ' + (this.index + 1) + ' of ' + this.slides.length;
      this.hydrate(this.slides[this.index]);
      this.sync(); this.warmNext();
    }
    click(e) {
      const button = e.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-slide-to')) this.show(Number(button.dataset.slideTo), true);
      const slide = button.closest('[data-slide]');
      if (!slide) return;
      const v = slide.querySelector('video');
      if (button.hasAttribute('data-play') && v) {
        if (v.paused) { slide.dataset.userPaused = 'false'; slide.dataset.manualPlay = 'true'; this.play(slide,true); }
        else { slide.dataset.userPaused = 'true'; v.pause(); }
      }
      if (button.hasAttribute('data-mute') && v) { v.muted = !v.muted; if (!v.muted && !v.volume) v.volume = 1; this.videoUI(slide); }
      if (button.hasAttribute('data-external-play')) {
        const host = slide.querySelector('[data-external-id]'); if (!host) return;
        const id = encodeURIComponent(host.dataset.externalId);
        const url = host.dataset.externalType === 'youtube' ? 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0' : host.dataset.externalType === 'vimeo' ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1' : null;
        if (!url) return;
        const iframe = document.createElement('iframe'); iframe.title = 'Addax campaign video'; iframe.allow = 'autoplay; fullscreen; picture-in-picture'; iframe.allowFullscreen = true; iframe.src = url;
        host.replaceChildren(iframe); slide.classList.add('has-external'); button.hidden = true; this.rotationPaused = true; this.schedule(); iframe.focus();
      }
    }
    videoUI(slide) {
      const v = slide.querySelector('video'); if (!v) return;
      const audible = !v.muted && v.volume > 0;
      slide.classList.toggle('is-playing',!v.paused); slide.classList.toggle('is-audible',audible);
      slide.querySelector('[data-play]')?.setAttribute('aria-label',v.error ? 'Retry video' : v.paused ? (v.ended ? 'Replay video' : 'Play video') : 'Pause video');
      const mute = slide.querySelector('[data-mute]'); mute?.setAttribute('aria-label',audible ? 'Mute video' : 'Unmute video'); mute?.setAttribute('aria-pressed',String(audible));
      const level = audible ? v.volume : 0;
      const volume = slide.querySelector('[data-volume]'); if (volume) volume.value = level;
      slide.querySelector('.acs__volume-popover')?.style.setProperty('--acs-volume',(level * 100) + '%');
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.abort || this.slides.length < 2 || this.rotationPaused || this.gesture || this.transition || !this.visible || document.hidden || this.hovered || this.editorSelected) return;
      this.timer = setTimeout(() => this.show(this.index + 1),this.interval);
    }
    disconnectedCallback() {
      this.dragEnd(null, true, true);
      const transition = this.transition; this.transition = null; this.queuedSlide = null;
      transition?.animations.forEach(a => a.cancel());
      this.classList.remove('is-settling');
      document.removeEventListener('DOMContentLoaded',this.start);
      cancelAnimationFrame(this.initFrame); clearTimeout(this.timer); clearTimeout(this.warmTimer); this.observer?.disconnect();
      cancelAnimationFrame(this.viewportFrame); this.viewportObserver?.disconnect();
      this.abort?.abort(); this.abort = null;
      this.slides?.forEach(s => { this.release(s); this.stopExternal(s); });
      this.classList.remove('is-ready');
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
